import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheStorageAdapter } from './cache-storage';

export class CacheDataSet {
  public cacheMethod: (ctx: CacheContext) => Observable<CacheProgress>;
  public getInfo: () => CacheDataSetInfo;

  constructor(public name: string, public weight?: number, public tableNames?: string[]) {}

  public getWeight(): number {
    if (!this.weight || this.weight <= 0.0) {
      return 1.0;
    }
    return this.weight;
  }
}

export class CacheDataSetInfo {
  constructor(public maxZoom?: number) {}
}

export enum CacheExtentMode {
  CurrentView = 0,
  InitialView = 1,
  UserExtent = 2,
}

export class CacheContext {
  public isCancelled: boolean;
  constructor(
    public storage: CacheStorageAdapter,
    public zoomLevel: number,
    public extentMode: CacheExtentMode,
    public selectedExtent?: number[]
  ) {}

  public checkCancelled(progress: Subject<CacheProgress>): boolean {
    if (this.isCancelled) {
      progress.complete();
      return true;
    }
    return false;
  }
}

export class CacheProgress {
  constructor(
    public stepCurrentValue: number,
    public errorCurrentValue: number = null,
    public errorMessage: string = null
  ) {}

  public static toObservable(progress: Subject<CacheProgress>): Observable<CacheProgress> {
    return progress.asObservable().pipe(
      tap((_) => {
        if (_.stepCurrentValue + _.errorCurrentValue >= 1.0) {
          progress.complete();
        }
      })
    );
  }
}
